import { DetailText } from "@gnist/design-system";
import { styled } from "styled-components";
import { tokens } from "@gnist/themes/tokens.css.js";

type props = {
  propertyDesc: string;
  propertyVal: string | number;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  overflow: hidden;
`;

const StyledDetailText = styled(DetailText)`
  font-size: ${tokens.typeface.size.s};
  font-weight: ${tokens.typeface.weight.regular};
`;

const PropertyValue = styled.div`
  font-size: ${tokens.typeface.size.s};
  font-weight: ${tokens.typeface.weight.medium};
`;

const CarProperty = ({ propertyDesc, propertyVal }: props) => {
  return (
    <Wrapper>
      <StyledDetailText>{propertyDesc}</StyledDetailText>
      <PropertyValue>{propertyVal}</PropertyValue>
    </Wrapper>
  );
};

export default CarProperty;
